import { useEffect, useState } from 'react';

const useMobileMainMenu = (items) => {
  const [path, setPath] = useState([]);

  useEffect(() => {
    setPath([]);
  }, [items]);

  return {
    showBackButton: path.length > 0,
    currentItems: path.length > 0 ? path[path.length - 1].list : items,
    onItemClick: (e, it) => {
      if (Array.isArray(it.list) && it.list.length > 0) {
        e.preventDefault();
        setPath([...path, it]);
      } else if (it.url == null) {
        e.preventDefault();
      }
    },
    onBackClick: (e) => {
      e.preventDefault();
      setPath(path.slice(0, -1));
    },
  };
};
export default useMobileMainMenu;
